'use client';

import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@tanstack/react-query';
import { postReservation } from '@/app/cc/_apis/consultation/postReservation';
import { handleResultModal } from '@/app/cc/_component/ui/modal/ConsultationModal/ResultModal';
import { useMutationErrorAlert } from '@/app/cc/_hooks/useMutationErrorAlert';
import type { ConsultationFormData } from '@/app/cc/_types/consultationForm';
export function useConsultation(t0) {
  const $ = _c(10);
  const {
    onClose,
    formData
  } = t0;
  const handleMutationError = useMutationErrorAlert();
  let t1;
  if ($[0] !== formData) {
    t1 = () => postReservation({
      name: formData.name,
      phone: formData.phone,
      inflow: formData.inflow,
      counselingTime: formData.counselingTime,
      contractFlag: formData.contractFlag,
      privacyUseFlag: formData.privacyUseFlag,
      privacyProvideFlag: formData.privacyProvideFlag
    });
    $[0] = formData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onClose) {
    t2 = () => {
      handleResultModal(onClose);
    };
    $[2] = onClose;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== handleMutationError) {
    t3 = error => {
      handleMutationError(error, {
        defaultMessage: "\uC0C1\uB2F4 \uC2E0\uCCAD\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.",
        rules: [{
          code: 500,
          fallback: "\uC0C1\uB2F4 \uC2E0\uCCAD\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.\n \uC785\uB825\uD55C \uC815\uBCF4\uB97C \uD655\uC778\uD574 \uC8FC\uC138\uC694.",
          messageFrom: []
        }]
      });
    };
    $[4] = handleMutationError;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = {
      mutationFn: t1,
      onSuccess: t2,
      onError: t3
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return useMutation(t4);
}